import { apiRequest } from '@/api/client';
import {
  notificationFeedResponseSchema,
  notificationPreferencesResponseSchema,
  type NotificationFeedResponse,
  type NotificationFilter,
  type NotificationPreferencesResponse,
  type UnreadCountResponse,
  type UpdateNotificationPreferencesRequest,
  unreadCountResponseSchema,
} from '@/types/notifications';

const NOTIFICATIONS_BASE = '/api/v1/notifications';
const PREFERENCES_BASE = '/api/v1/notification-preferences';

export async function getNotifications(params: {
  cursor?: string;
  limit?: number;
  filter?: NotificationFilter;
}): Promise<NotificationFeedResponse> {
  const sp = new URLSearchParams();
  if (params.cursor) sp.set('cursor', params.cursor);
  if (params.limit !== undefined) sp.set('limit', String(params.limit));
  if (params.filter) sp.set('filter', params.filter);
  const q = sp.toString();
  const url = `${NOTIFICATIONS_BASE}${q ? `?${q}` : ''}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return notificationFeedResponseSchema.parse(res);
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const res = await apiRequest<unknown>({ url: `${NOTIFICATIONS_BASE}/unread-count`, method: 'GET' });
  return unreadCountResponseSchema.parse(res);
}

export async function markAsRead(id: string): Promise<void> {
  await apiRequest<unknown>({ url: `${NOTIFICATIONS_BASE}/${id}/read`, method: 'PATCH' });
}

export async function markAllAsRead(): Promise<void> {
  await apiRequest<unknown>({ url: `${NOTIFICATIONS_BASE}/mark-all-read`, method: 'POST' });
}

export async function getNotificationPreferences(): Promise<NotificationPreferencesResponse> {
  const res = await apiRequest<unknown>({ url: PREFERENCES_BASE, method: 'GET' });
  return notificationPreferencesResponseSchema.parse(res);
}

export async function updateNotificationPreferences(
  body: UpdateNotificationPreferencesRequest,
): Promise<NotificationPreferencesResponse> {
  const res = await apiRequest<unknown>({ url: PREFERENCES_BASE, method: 'PATCH', data: body });
  return notificationPreferencesResponseSchema.parse(res);
}
